<template>
  <div class="check-name" v-if="data.checkCompanyNameStatus">
    <div class="box">
      <div>{{ data.text }}</div>
      <div class="item" v-for="(item, index) in data.userinfos" :key="index">
        <xl-avatar v-if="item?.userName || item?.id" :avatar="{ name: item?.userName || '', url: item?.avatarOrigin, id: item?.id }" :size="18" />
        <!-- <img v-if ="item?.userName" :src="item?.avatarOrigin" /> -->
        <!-- <div>{{ item?.userName }}</div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import useCheckOption from '@/hooks/checkname';
import { useI18n } from 'vue-i18n';
const { clueCheckFieldRepeat, customerCheckFieldRepeat, opportunityCheckFieldRepeat } = useCheckOption();
const { t } = useI18n();
const data = reactive({
  text: '',
  checkCompanyNameStatus: false,
  userinfos: [],
  url: null
});
const companyInputc = async (e, modulesItem, type, operation) => {
  if (operation == 40) return;
  if (type == 'companyName') data.url = clueCheckFieldRepeat;
  if (type == 'customerName') data.url = customerCheckFieldRepeat;
  if (type == 'opportunityName') data.url = opportunityCheckFieldRepeat;
  const res = await data.url(e, modulesItem.value);
  data.checkCompanyNameStatus = res?.checkCompanyNameStatus;
  data.userinfos = res?.userinfos;
  if (data?.userinfos?.length == 0) {
    data.text = t('该名称已存在，当前无负责人');
  } else {
    data.text = t('该名称已存在，当前负责人为');
  }
};
defineExpose({ companyInputc });
</script>
<style scoped lang="less">
@import './xl-check-name.less';
</style>
